import axios, { AxiosResponse } from 'axios';

export interface TSystemSettingsAskAliseRes {
  allow_ask_alise: boolean;
}

export interface TSystemSettingsAskAliseParams {
  allow_ask_alise: boolean;
}

export const getAskAliseVisibilityConfig = (): Promise<
  AxiosResponse<TSystemSettingsAskAliseRes>
> => {
  return axios.get('/system-settings/');
};

export const updateAskAliseVisibilityConfig = (
  payload: TSystemSettingsAskAliseParams
): Promise<AxiosResponse<TSystemSettingsAskAliseRes>> => {
  return axios.put('/system-settings/', payload);
};
